import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MediaPlayer, MediaProvider } from "@vidstack/react";
import { cn } from "../../../../utils";
import VideoLayout from "../VideoLayout";
const ErrorPlayer = ({ className }) => (_jsxs(MediaPlayer, { className: cn("group aspect-video gap-2 overflow-hidden rounded-md bg-black p-2 pb-[75px]", className), "data-testid": "error-video-player", "data-error": true, children: [_jsx(MediaProvider, {}), _jsx(VideoLayout, { medias: [] })] }));
export default ErrorPlayer;
